/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable consistent-return */
// eslint-disable-next-line no-use-before-define
import React, { ReactElement, useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  message,
  notification,
  Row,
  Spin,
} from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { SchemaOf } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Redirect, useHistory } from 'react-router-dom';

import {
  emailValidateMessage,
  requiredValidateMessage,
} from 'utils/validation';
import { loginUser, querySsoRedirect } from 'pages/signIn/signIn.service';
import { config } from 'core/config';
import { ApplicationState } from 'store/combineReducers';
import { baseUrlUser, statusCodesCheck } from 'utils/api';
import { consumePostLoginPath } from 'utils/postLogin';
import { passwordIconRender } from 'utils/helperRender';
import { useTranslation } from 'react-i18next';
import LocalesDropdown from 'layout/components/localesDropdown';
import {
  setStoreLanguage,
  getStoredSsoConfig,
  storeAccessToken,
  storeRefreshToken,
} from 'utils/localStorage';
import { changeLanguageTmp } from 'i18n';
import getCurrentUser, { initSite } from 'routes/routes.service';
import LoginRedirect from 'pages/signIn/redirect';
import { apiCheckTenant } from 'pages/siteEntry';
import getSetting from 'core/service/setting.service';
import { apiChooseSite } from 'pages/sites/sites.service';
import { getTenantId, isMobileApp } from 'utils/util';
import { getVivalinkSsoCookie, notifyMfaSuccess } from 'utils/auth';
import {
  apiSSOEnableList,
  apiSSOLogin,
} from 'pages/settings/ssoSetting/sso.service';
import { languageMap } from 'constant/common';

const { Item } = Form;
const { Password } = Input;
const { restorePassword, totpConfirm } = config.paths;

export interface SignInFormData {
  email: string;
  password: string;
  request: string | undefined;
}

const signInSchema = (): SchemaOf<SignInFormData> => {
  return yup.object().shape({
    email: yup
      .string()
      .required(requiredValidateMessage)
      .email(emailValidateMessage),
    password: yup.string().required(requiredValidateMessage),
    request: yup.string().optional(),
  });
};

interface SignInProps {
  request: string;
}
export default function SignIn({ request }: SignInProps): ReactElement {
  const { rechangePassword } = config.paths;
  const [userEmail, setUserEmail] = useState('');
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [ssoData, setSsoData] = useState<Record<string, any>[]>([]);
  const [hasSite, setHasSite] = useState(false);
  const [isPasswordExpire, setIsPasswordExpire] = useState(false);
  const [domainUrl] = useState(
    window?.__APP_CONFIG__?.DOMAIN_URL || process.env.DOMAIN_URL || 'localhost',
  );
  const { isAuth } = useSelector((state: ApplicationState) => state.session);

  const ssoConfig = getStoredSsoConfig();
  const [responseErrorMessage, setResponseErrorMessage] = useState('');
  const searchParams = new URLSearchParams(history?.location?.search);

  const initSSO = async () => {
    const res = await apiSSOEnableList(getTenantId());
    if (res?.status === 200) {
      console.log(res);
      setSsoData(res?.data?.list || []);
    }
  };

  async function validateTenant() {
    const { host, protocol } = window.location;
    if (host.includes('.')) {
      const hostArr = host.split('.');
      try {
        const res = await apiCheckTenant(hostArr[0]);
        if (res.status === 200) {
          localStorage.setItem('tenantData', JSON.stringify(res.data));
          initSSO();
          const queryParams = new URLSearchParams(window.location.search);
          const from = queryParams.get('from');
          if (from === 'sso') {
            const tokenStr = getVivalinkSsoCookie('vivalinksso');
            if (!tokenStr) {
              setResponseErrorMessage(t('message.sso.error'));
              setHasSite(true);
              return;
            }
            const cookieMap: any = {};
            tokenStr?.split('&').forEach((item) => {
              const [key, value] = item.split('=');
              cookieMap[key] = value;
            });
            if (cookieMap.accessToken) {
              storeAccessToken(cookieMap.accessToken);
            }
            if (cookieMap.refreshToken) {
              storeRefreshToken(cookieMap.refreshToken);
            }
            if (cookieMap?.mfaRequired === 'true') {
              // store.dispatch(setMfa());
              history.push(totpConfirm);
              return;
            }
            console.log('navigator.userAgent', navigator.userAgent);
            console.log('cookieMap', cookieMap);
            if (isMobileApp()) {
              const { accessToken, refreshToken } = cookieMap;
              notifyMfaSuccess(accessToken, refreshToken);
            } else {
              initConfig();
            }
          }
          const token = queryParams.get('token');
          const superTenant = queryParams.get('supertenant');
          if (superTenant) {
            sessionStorage.setItem('superTenantName', superTenant);
          }
          if (token) {
            const tokenRes = await apiChooseSite(res?.data?.siteId, {
              token,
            });
            const { accessToken, siteId, refreshToken } = tokenRes.data;
            sessionStorage.setItem('siteId', siteId);
            storeAccessToken(accessToken);
            if (refreshToken) {
              storeRefreshToken(refreshToken);
            }
            const resUser = await getCurrentUser();
            if (resUser?.status === 200) {
              const target = consumePostLoginPath();
              history.push(target || baseUrlUser(resUser?.data?.roles[0].name));
            }
            await getSetting();
            initSite(getTenantId());
          } else {
            setHasSite(true);
          }
        }
      } catch {
        notification.error({
          message: t('message.tenant.error'),
        });
        window.location.href = `${protocol}//${domainUrl}`;
      }
    } else {
      window.location.href = `${protocol}//${domainUrl}`;
    }
  }

  useEffect(() => {
    validateTenant();
  }, []);

  useEffect(() => {
    const language = searchParams.get('language');
    if (language != null) {
      const lan = languageMap[language] || language;
      setStoreLanguage(lan);
      changeLanguageTmp();
    }
  }, [history]);

  const { control, errors, handleSubmit } = useForm<SignInFormData>({
    resolver: yupResolver(signInSchema()),
    mode: 'onChange',
    defaultValues: {
      email: '',
      password: '',
      request: '',
    },
  });

  function handleAlertClose(): void {
    setResponseErrorMessage('');
  }

  const initConfig = async () => {
    await getCurrentUser();
    await getSetting();
    initSite(getTenantId());
  };

  async function onSubmit(data: SignInFormData): Promise<void> {
    data.request = request || searchParams.get('authRequest') || '';
    setUserEmail(data?.email);
    const response = await loginUser(data);
    if (response && statusCodesCheck(response)) {
      if (response.data?.callback) {
        window.location.assign(response.data.callback);
        return;
      }
      if (response?.data?.user?.mfaRequired) {
        // store.dispatch(setMfa());
        history.push(totpConfirm);
        return;
      }
      if (navigator.userAgent.indexOf('VivaAI-Mobile') !== -1) {
        const { accessToken, refreshToken } = response.data;
        notifyMfaSuccess(accessToken, refreshToken);
      } else {
        initConfig();
      }
    } else if (response && response.status === 301) {
      setTimeout(() => {
        window.location.replace('/');
      }, 500);
    } else {
      console.log(response);
      if (response?.data?.reason === 'Password_Expired') {
        setIsPasswordExpire(true);
        setResponseErrorMessage(t('message.expire.passowrd.info'));
      } else {
        setResponseErrorMessage((response && response.data?.message) || '');
      }
    }
  }

  if (isAuth) {
    return <LoginRedirect />;
  }

  const [checkboxValue, setCheckboxValue] = useState(true);
  const onChangeCheckbox = (e: CheckboxChangeEvent) => {
    setCheckboxValue(e.target.checked);
  };

  const handleSSO = async () => {
    window.location.href = `${window.origin}/api/backend/sso/saml/login?id=${
      ssoData?.[0]?.id
    }&tenantId=${getTenantId()}`;
  };

  if (!hasSite) {
    return <Spin />;
  }

  return (
    <Row
      justify="center"
      align={isMobileApp() ? 'top' : 'middle'}
      className="full-height-page with-header"
      style={isMobileApp() ? { margin: '24px 12px 0' } : undefined}
    >
      <Col style={{ width: '410px' }}>
        <div className="vivalink-title">{t('signIn.title')}</div>
        <Card>
          {!!responseErrorMessage && (
            <Alert
              message={
                <span>
                  {responseErrorMessage}
                  {isPasswordExpire && (
                    <Link
                      style={{ marginLeft: 6 }}
                      to={{
                        pathname: `${rechangePassword}`,
                        state: { email: userEmail },
                      }}
                    >
                      {t('message.expire.passowrd.btn.label')}
                    </Link>
                  )}
                </span>
              }
              type="error"
              showIcon
              closable
              onClose={handleAlertClose}
            />
          )}
          <Form layout="vertical">
            <Item
              label={t('signIn.form.email.label')}
              validateStatus={errors.email && 'error'}
              help={errors.email?.message}
            >
              <Controller
                control={control}
                name="email"
                render={(field) => (
                  <Input
                    {...field} // eslint-disable-line react/jsx-props-no-spreading
                    placeholder={t('signIn.form.email.placeholder')}
                  />
                )}
              />
            </Item>
            <Item
              label={t('signIn.form.password.label')}
              validateStatus={errors.password && 'error'}
              help={errors.password?.message}
            >
              <Controller
                as={
                  <Password
                    autoComplete="off"
                    placeholder={t('signIn.form.password.placeholder')}
                    iconRender={passwordIconRender}
                  />
                }
                control={control}
                name="password"
              />
            </Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: '100%' }}
              onClick={handleSubmit(onSubmit)}
              disabled={!checkboxValue}
            >
              {t('signIn.button.signIn')}
            </Button>
            {ssoData?.length >= 1 && (
              <Button
                style={{ width: '100%', marginTop: 12 }}
                onClick={handleSSO}
                disabled={!checkboxValue}
              >
                {t('signIn.button.sso')}
              </Button>
            )}
          </Form>
          <br />
          <div
            style={{
              fontSize: '12px',
              color: '#595959',
              textAlign: 'left',
              paddingBottom: '10px',
            }}
          >
            <Checkbox onChange={onChangeCheckbox} checked={checkboxValue}>
              <span
                style={{
                  fontSize: '12px',
                  color: '#595959',
                  textAlign: 'left',
                  paddingBottom: '10px',
                }}
              >
                {t('signIn.checkbox.label')}{' '}
                <a
                  href="https://www.vivalink.com/terms-conditions"
                  target="_blank"
                >
                  {t('signIn.aHref.termsConditions')}
                </a>{' '}
                {t('common.and.lowercase')}{' '}
                <a
                  href="https://www.vivalink.com/privacy-policy"
                  target="_blank"
                >
                  {t('signIn.aHref.privacyPolicy')}
                </a>
              </span>
            </Checkbox>
          </div>
          <Row justify="end">
            <Link to={restorePassword}>{t('signIn.button.forgot')}</Link>
          </Row>
        </Card>
        {/* <LocalesDropdown /> */}
      </Col>
    </Row>
  );
}
